<template>
  <div>
    <div class="ts-relative ts-w-full">
      <form @submit.prevent="findSerial">
        <input
          v-model.trim="serial_no"
          ref="search"
          type="text"
          class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
          :placeholder="$t('stockReturn.searchSerial')"
        />
        <button
          type="submit"
          class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
          style="margin-top: 7px"
        >
          <i class="fa fa-search"></i>
        </button>
      </form>
    </div>
    <br /><br />
    <div>
      <table class="ts-w-full" id="table-detail">
        <thead>
          <tr>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
            >
              {{ $t('stockReturn.barcode') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
            >
              {{ $t('stockReturn.productName') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
            >
              {{ $t('stockReturn.uom') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center"
            >
              {{ $t('stockReturn.qty') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right"
            >
              {{ $t('stockReturn.unitPrice') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center"
            >
              {{ $t('stockReturn.grade') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="ts-border-b ts-cursor-pointer ts-relative"
            v-for="(d, index) in model.product_detail"
            :key="index"
          >
            <td class="ts-px-2 ts-py-2">{{ d.barcode }}</td>
            <td class="ts-px-2 ts-py-2">{{ d.product_name_en }}</td>
            <td class="ts-px-2 ts-py-2 ts-w-16">{{ d.uom_name_en }}</td>
            <td class="ts-px-2 ts-py-2 ts-text-center ts-w-20">
              <input
                type="number"
                v-model="d.quantity"
                class="ts-px-3 ts-w-16 ts-outline-none"
                :readonly="d.serial_list.length > 0"
              />
            </td>
            <td class="ts-px-2 ts-py-2 ts-text-right ts-w-20">
              <ts-currency-input
                v-model="d.sale_price"
                class="form-control ts-text-right"
                style="min-width: 100px"
              />
            </td>
            <td class="ts-px-2 ts-py-2 ts-text-center">
              {{ d.product_grade }}
              <span class="ts-absolute">
                <a
                  href="#"
                  class="ts-mr-5"
                  v-if="d.serial_list.length > 0"
                  @click.prevent="viewSerial(d)"
                  ><i class="fas fa-bars"></i
                ></a>
                <a
                  href="#"
                  class="ts-text-red-600"
                  @click.prevent="removeItem(index)"
                  ><i class="fas fa-trash"></i
                ></a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <a-modal
        v-model="visible_serial"
        :title="$t('stockReturn.serial')"
        :footer="null"
        :centered="true"
        width="300px"
      >
        <table class="ts-w-full">
          <tbody>
            <tr
              class="ts-border-b "
              v-for="(s, index) in serials.serial_list"
              :key="index"
            >
              <td>{{ s }}</td>
              <td class="ts-w-5 ts-px-2 ts-py-2">
                <a
                  href="#"
                  class="ts-text-red-600"
                  @click.prevent="removeSerial(index)"
                  ><i class="fas fa-times ts-text-red-600"></i
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
      </a-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      serial_no: null,
      visible_serial: false,
      serials: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    findSerial() {
      if (!this.serial_no) return

      this.$emit('loading', true)
      this.$store
        .dispatch('stock/stockReturn/findProduct', this.serial_no)
        .then(response => {
          if (response.data.serial_no) {
            this.addProductSerial(response.data)
          } else {
            this.addProduct(response.data)
          }
        })
        .catch(error => {
          this.$notification.error({
            placement: 'bottomRight',
            message: 'Errors',
            description: error.message,
            style: { 'z-index': 1021, color: 'red' }
          })
        })
        .finally(() => this.$emit('loading', false))
    },
    addProduct(data) {
      if (data) {
        let productExisting = this.model.product_detail.find(
          p =>
            p.product_id == data.product_id &&
            p.product_grade == data.product_grade
        )
        if (productExisting) {
          productExisting.quantity = productExisting.quantity + 1
        } else {
          this.model.product_detail.push({
            barcode: data.barcode,
            product_name_en: data.product_name_en,
            product_id: data.product_id,
            uom_id: data.uom_id,
            uom_name_en: data.uom_name_en,
            product_grade: data.product_grade,
            sale_price: data.sale_price,
            serial_list: [],
            quantity: 1
          })
        }
        this.serial_no = null
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    addProductSerial(data) {
      if (data) {
        let existingProduct = this.model.product_detail.find(
          p =>
            p.product_id == data.product_id &&
            p.product_grade == data.product_grade
        )
        if (existingProduct) {
          let existingSerial = existingProduct.serial_list.find(
            s => s == data.serial_no
          )
          if (!existingSerial) {
            existingProduct.serial_list.push(data.serial_no)
            existingProduct.quantity = existingProduct.serial_list.length
          } else {
            this.notification({
              type: 'Errors',
              color: 'red',
              description:
                'Serial Number: ' +
                data.serial_no +
                ' already exists in ' +
                data.product_name_en
            })
          }
        } else {
          this.model.product_detail.push({
            barcode: data.barcode,
            product_name_en: data.product_name_en,
            product_id: data.product_id,
            uom_id: data.uom_id,
            uom_name_en: data.uom_name_en,
            product_grade: data.product_grade,
            sale_price: data.sale_price,
            serial_list: [data.serial_no],
            quantity: 1
          })
          this.notification({
            type: 'Info',
            description:
              'Serial Number: ' +
              data.serial_no +
              ' added to ' +
              data.product_name_en
          })
        }
        this.serial_no = null
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    removeItem(index) {
      this.model.product_detail.splice(index, 1)
    },
    viewSerial(serial) {
      this.visible_serial = true
      this.serials = serial
    },
    removeSerial(serial, index) {
      this.serials.serial_list.splice(index, 1)
      this.serials.quantity = this.serials.quantity - 1
    },
    notification({ type = 'Info', color = '#135e5e', description = null }) {
      this.$notification.info({
        placement: 'bottomRight',
        message: type,
        description: description,
        style: { 'z-index': 1021, color: color }
      })
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 240px;
  max-height: 250px;
  overflow: scroll;
}
#table-detail {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
#table-detail thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}

#table-detail tbody tr span {
  display: none;
}
#table-detail tbody tr:hover {
  background: rgba(255, 255, 255, 0.419);
  opacity: 20;
  box-shadow: 0 0 5px rgb(197, 197, 197);
}
#table-detail tbody tr:hover span {
  display: inline-block;
  top: 0;
  right: 0;
  margin: 10px 20px 0 0;
  color: rgb(85, 85, 85);
}
</style>
